<chitin-icon
  style="cursor: pointer"
  [icon]="copied() ? 'fa-solid fa-check' : 'fa-regular fa-files'"
  [ngbTooltip]="copied() ? 'Value was copied to clipboard' : 'Copy to clipboard'"
  (click)="copyToClipboard()"
/>
